import { useCallback } from 'react';
import { useEStop, useJogFeedRate, useJogIncrement, useSendCommand } from '@/store/store';

export interface UseJogResult {
  /** True while E-stop is active — jog controls should be disabled. */
  estop: boolean;
  onStart: (axisIndex: number, dir: 1 | -1) => void;
  onStop: (axisIndex: number) => void;
}

/** Shared jog command wiring: one press moves the axis by the selected step size. */
export function useJog(): UseJogResult {
  const estop = useEStop();
  const sendCommand = useSendCommand();
  const feedRate = useJogFeedRate();
  const increment = useJogIncrement();

  const onStart = useCallback(
    (axisIndex: number, dir: 1 | -1) => {
      // Step jog: each press moves exactly `increment` mm, then stops on its own.
      sendCommand({ type: 'JOG', axis: axisIndex, dir, speed: feedRate, distance: increment });
    },
    [sendCommand, feedRate, increment],
  );

  const onStop = useCallback(() => {
    // An increment move completes by itself — releasing the button is a no-op.
  }, []);

  return { estop, onStart, onStop };
}
